import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";

import { HELP_MUSIC_ON_HOLDS } from "@/constants/HelpUrls";
import MasterDetail from "@/design/layouts/MasterDetail";
import { setHelpUrl } from "@/store/reducers/ui";

import { useHotkey } from "@tanstack/react-hotkeys";

import MusicOnHold from "./MusicOnHold";
import MusicOnHoldList from "./MusicOnHoldList";

export default function MusicOnHolds() {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setHelpUrl(HELP_MUSIC_ON_HOLDS));
  }, [dispatch]);

  useHotkey("Alt+N", () => navigate(`/pbx/${params.pbxId}/media/music-on-hold/new`));

  return <MasterDetail identifier="id" master={<MusicOnHoldList />} detail={<MusicOnHold />} />;
}
